import request from 'services/request';
import { endpoints } from 'services/endpoints';

export default {
  /** 노출 중인 온보딩 팝업 목록 조회 */
  getOnboardingInfo: (params?: { isBypassOnboardingYn: boolean }): Promise<PopupInfoDetailResDto> => {
    return request({
      url: endpoints.popup.displayOnboarding,
      method: 'GET',
      params,
    });
  },

  /** 온보딩 팝업 열람 완료 */
  readOnboarding: (): Promise<BaseResDto> => {
    return request({
      url: endpoints.popup.readOnboarding,
      method: 'PUT',
    });
  },

  /** 노출 중인 EP 이벤트 팝업 목록 조회 */
  getEPEventPromotionInfo: (): Promise<PopupInfoDetailResDto> => {
    return request({
      url: endpoints.popup.displayEPEventPromotion,
      method: 'GET',
    });
  },

  /** EP 이벤트 팝업 열람 처리 */
  readEPEventPromotion: (params: PopupReadReqDto): Promise<BaseResDto> => {
    return request({
      url: endpoints.popup.readEPEventPromotion,
      method: 'PUT',
      data: params,
    })
  },

  /** 노출 중인 일반 팝업 조회 */
  getNormalPopupInfo: (): Promise<PopupInfoDetailResDto> => {
    return request({
      url: endpoints.popup.displayNormal,
      method: 'GET',
    });
  },

  /** 일반 팝업 열람 처리 */
  readNormalPopup: (params: PopupReadReqDto): Promise<BaseResDto> => {
    return request({
      url: endpoints.popup.readNormal,
      method: 'PUT',
      data: params,
    })
  },
};
